export const getOperationList = state => state.operationList;
